import type { CustomElementOptions } from "vue";

export interface EConnectElementOptions {
  /**
   * Whether to enable server-side rendering for the custom element.
   * @default false
   */
  ssr?: boolean;

  /**
   * Whether the custom element should be form-associated.
   * Form-associated elements can participate in form submission and validation.
   * @default false
   */
  formAssociated?: boolean;

  /**
   * Whether to add form submission capabilities to the custom element.
   * @default false
   */
  formSubmitter?: boolean;

  /**
   * Whether to automatically trim whitespace-only text nodes from default slots.
   * @default true
   */
  trimDefaultSlotWhitespace?: boolean;

  /**
   * Options to pass to Vue's defineCustomElement.
   */
  customElementOptions?: CustomElementOptions;
}

export const defaultElementOptions: EConnectElementOptions = {
  ssr: false,
  formAssociated: false,
  formSubmitter: false,
  trimDefaultSlotWhitespace: true,
  customElementOptions: {
    shadowRoot: true,
  },
};
